import React from 'react';
import { Landmark, Check, Plus } from 'lucide-react';

export const ZiyaratAddons = ({ ziyarat, busy, onChange, compact = false }) => {
  if (!ziyarat?.options?.length) return null;
  const selected = ziyarat.selected || [];
  const toggle = (code) => onChange(selected.includes(code) ? selected.filter((c) => c !== code) : [...selected, code]);
  return (
    <section className="space-y-2" data-testid="pkg-ziyarat">
      <h4 className="font-bold text-slate-900 flex items-center gap-2"><Landmark className="h-4 w-4 text-[#FF6600]" />Ziyarat add-ons <span className="text-xs font-normal text-slate-500">optional · private vehicle sized for {ziyarat.options[0].passengers} traveller{ziyarat.options[0].passengers !== 1 ? 's' : ''}</span></h4>
      <div className={`grid gap-2 ${compact ? 'grid-cols-1' : 'sm:grid-cols-2'}`}>
        {ziyarat.options.map((o) => {
          const on = selected.includes(o.code);
          return (
            <button key={o.code} type="button" disabled={busy} onClick={() => toggle(o.code)} aria-pressed={on} data-testid={`pkg-ziyarat-${o.code}`}
              className={`text-left rounded-xl border-2 p-3 transition-colors disabled:opacity-60 ${on ? 'border-[#FF6600] bg-orange-50' : 'border-slate-200 hover:border-slate-400 bg-white'}`}>
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="font-bold text-slate-900">{o.name}</div>
                  <div className="text-xs text-slate-500">{o.duration} · {o.vehicle_name}{o.vehicles > 1 ? ` × ${o.vehicles}` : ''}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="text-xs font-semibold text-emerald-700" data-testid={`pkg-ziyarat-${o.code}-price`}>{on ? 'Included in package price' : 'Price included on selection'}</div>
                </div>
              </div>
              {!compact && <div className="mt-2 text-xs text-slate-600">{o.sights.join(' · ')}</div>}
              <div className={`mt-2 inline-flex items-center gap-1 text-xs font-semibold ${on ? 'text-[#FF6600]' : 'text-slate-600'}`}>{on ? <><Check className="h-3.5 w-3.5" />Added to package</> : <><Plus className="h-3.5 w-3.5" />Add to package</>}</div>
            </button>
          );
        })}
      </div>
    </section>
  );
};
